import React from "react";
import cn from "classnames";
import styles from "./Comments.module.sass";
import Icon from "../../../Icon";
// import Item from "./Item";
import TooltipGlobal from "../../../TooltipGlobal";
// import Editor from "../../../Editor";

// data
// import { commentsProduct } from "../../../../mocks/comments";

const Comments = ({ className, onClose }) => {

    // const [content, setContent] = useState();

    return (
        <>
            <div className={cn(styles.comments, className)}>
                <div className={styles.head}>
                    <div className={styles.title}>
                        <div className={styles.counter}>4</div>
                        Timeline Items
                    </div>
                    <button className={styles.close} onClick={onClose}>
                        <Icon name="close" size="24" />
                    </button>
                </div>
            </div>
            <TooltipGlobal />
        </>
    );
};

export default Comments;
